export default __webpack_public_path__ + "static/tetiana-2968d9a04b56e5a1bf7cb77b7e10444d.webp";